import { render, staticRenderFns } from "./Drones.vue?vue&type=template&id=a7c2981a&scoped=true&"
import script from "./Drones.vue?vue&type=script&lang=js&"
export * from "./Drones.vue?vue&type=script&lang=js&"
import style0 from "./Drones.vue?vue&type=style&index=0&id=a7c2981a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2981a",
  null
  
)

export default component.exports